import { render, staticRenderFns } from "./DirectReadPost.vue?vue&type=template&id=29497a76&scoped=true"
import script from "./DirectReadPost.vue?vue&type=script&lang=js"
export * from "./DirectReadPost.vue?vue&type=script&lang=js"
import style0 from "./DirectReadPost.vue?vue&type=style&index=0&id=29497a76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29497a76",
  null
  
)

export default component.exports